import { Component, ComponentFactoryResolver, Input, OnInit, ViewContainerRef } from '@angular/core';
import { InjectedComponentsBaseService } from '@core/framework/injected-components-base.service';

@Component({
    selector: 'm4u-injected-components',
    templateUrl: './injected-components.component.html'
})
export class InjectedComponentsComponent implements OnInit {
    @Input() Destination: string;

    constructor(private componentFactoryResolver: ComponentFactoryResolver, private viewContainerRef: ViewContainerRef,
        private service: InjectedComponentsBaseService) { }

    ngOnInit() {
        this.loadComponents();
    }

    loadComponents() {
        (this.service.GetComponents(this.Destination) || []).forEach((buttonComponent) => {
            const componentFactory = this.componentFactoryResolver.resolveComponentFactory(buttonComponent);
            componentFactory.inputs
            this.viewContainerRef.createComponent(componentFactory);
        });
    }
}
